import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import BaseMixer from "@/router/views/BaseMixer";
import ClockPicker from "@/components/widgets/clockPicker.vue";
import { interpret } from "xstate/lib/interpreter";
import { PAReviewModule } from "@/store/modules/paReview.module";
import { PAReviewScheduleMeetingModel } from "@/store/models/paReview/paReviewScheduleMeeting";
import reviewMeetingUpsertMachine from "../machines/reviewMeetingUpsertMachine";
let SetupReviewMeeting = /** @class */ (() => {
    let SetupReviewMeeting = class SetupReviewMeeting extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.reviewMeeting = new PAReviewScheduleMeetingModel();
            this.showError = false;
            this.machine = reviewMeetingUpsertMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        send(event) {
            this.machineService.send(event);
        }
        initialize() {
            this.machineService.send({
                type: "INITIALIZE",
                reviewId: this.reviewId,
                mode: this.mode,
                meetingId: this.meetingId,
            });
        }
        saveMeeting() {
            this.validate("meetingObserver").then((response) => {
                this.showError = true;
                if (this.hasSelectedParticipant) {
                    if (response) {
                        this.reviewMeeting.reviewId = this.state.context.reviewId;
                        this.modifyDateFormat();
                        this.machineService.send({
                            type: "SAVING_MEETING",
                            reviewMeeting: this.reviewMeeting,
                        });
                    }
                }
            });
        }
        modifyDateFormat() {
            this.reviewMeeting.reviewMeetingDateAsString = this.getFormattedDateString(this.reviewMeeting.reviewMeetingDate);
        }
        updateMeeting() {
            this.validate("meetingObserver").then((response) => {
                this.showError = true;
                if (this.hasSelectedParticipant) {
                    if (response) {
                        this.modifyDateFormat();
                        this.reviewMeeting.reviewParticipants.forEach((participant, index) => {
                            const foundParticipant = this.reviewMeetingParticipants.find((p) => p.id === participant.id);
                            if (foundParticipant) {
                                this.reviewMeeting.reviewParticipants[index] = {
                                    ...participant,
                                    ...foundParticipant,
                                };
                            }
                        });
                        this.machineService.send({
                            type: "UPDATING_MEETING",
                            reviewMeeting: this.reviewMeeting,
                        });
                    }
                }
            });
        }
        getFormattedDateString(value) {
            return `${value.getFullYear()}-${value.getMonth() + 1}-${value.getDate()}T00:00:00`;
        }
        get reviewMeetingParticipants() {
            return PAReviewModule.reviewMeetingParticipants;
        }
        get hasSelectedParticipant() {
            var value = this.reviewMeeting.reviewParticipants.filter((c) => !c.isUnEditable).length;
            return value > 0;
        }
        notify() {
            this.$emit("notify", this.machine.context.reviewId);
        }
        cancel() {
            this.machineService.send({
                type: "CANCEL_MEETING",
            });
            this.reviewMeetingParticipants.forEach((participant) => {
                if (!participant.isUnEditable) {
                    participant.isSelected = false;
                }
            });
            this.$emit("cancel", this.mode);
        }
        get paReviewMeetingDetail() {
            return PAReviewModule.paReviewMeetingDetail;
        }
        disabledAfterToday(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return date < new Date(today.getTime());
        }
        toggleParticipantSelection(participant) {
            const index = this.reviewMeeting.reviewParticipants.findIndex((p) => p.id === participant.id);
            if (index === -1) {
                this.reviewMeeting.reviewParticipants.push(participant);
            }
            else {
                if (!participant.isUnEditable) {
                    this.reviewMeeting.reviewParticipants.splice(index, 1);
                }
            }
        }
        isChecked(participant) {
            return this.reviewMeeting.reviewParticipants.some((p) => p.id === participant.id);
        }
        mounted() {
            this.reviewMeetingParticipants.forEach((participant) => {
                if (participant.isUnEditable && !this.isChecked(participant)) {
                    this.reviewMeeting.reviewParticipants.push(participant);
                }
            });
        }
        created() {
            this.initialize();
            this.machineService.start();
            this.machineService.onTransition((state) => {
                var previousState = this.state;
                this.state = state;
                if (this.mode === "Edit" && this.paReviewMeetingDetail) {
                    if (this.paReviewMeetingDetail.reviewMeetingDate) {
                        this.paReviewMeetingDetail.reviewMeetingDate = new Date(this.paReviewMeetingDetail.reviewMeetingDate);
                    }
                    this.reviewMeeting = { ...this.paReviewMeetingDetail };
                    if (this.reviewMeetingParticipants && Array.isArray(this.reviewMeetingParticipants)) {
                        if (this.reviewMeeting.reviewParticipants && Array.isArray(this.reviewMeeting.reviewParticipants)) {
                            this.reviewMeeting.reviewParticipants.forEach((participant) => {
                                const matchedParticipant = this.reviewMeetingParticipants.find((p) => p.id === participant.id);
                                if (matchedParticipant) {
                                    participant.name = matchedParticipant.name;
                                    matchedParticipant.isSelected = true;
                                }
                                else {
                                    matchedParticipant.isSelected = false;
                                }
                            });
                        }
                    }
                }
                if (state.hasTag("showReviewDetailUI")) {
                    this.notify();
                }
            });
        }
        destroyed() {
            this.machineService.stop();
            PAReviewModule.ClearReviewMeetingDetail();
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], SetupReviewMeeting.prototype, "reviewId", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], SetupReviewMeeting.prototype, "mode", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], SetupReviewMeeting.prototype, "meetingId", void 0);
    SetupReviewMeeting = __decorate([
        Component({
            name: "SetupReviewMeeting",
            components: {
                Loader,
                ClockPicker,
            },
        })
    ], SetupReviewMeeting);
    return SetupReviewMeeting;
})();
export default SetupReviewMeeting;
